// extracted by mini-css-extract-plugin
export var blue = "_j-f";
export var brand = "_j-b";
export var darkGrey = "_j-e";
export var disabled = "_j-4";
export var disabledSubtle = "_j-5";
export var error = "_j-6";
export var green = "_j-g";
export var grey = "_j-d";
export var icon = "_j-0";
export var inherit = "_j-a";
export var lightGrey = "_j-c";
export var orange = "_j-i";
export var pink = "_j-k";
export var primary = "_j-1";
export var purple = "_j-l";
export var red = "_j-j";
export var secondary = "_j-2";
export var success = "_j-9";
export var tertiary = "_j-3";
export var warning = "_j-7";
export var warningSecondary = "_j-8";
export var white = "_j-m";
export var yellow = "_j-h";